import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { EmotionalHook } from './components/EmotionalHook';
import { ProblemAgitation } from './components/ProblemAgitation';
import { PackPresentation } from './components/PackPresentation';
import { EbookShowcase } from './components/EbookShowcase';
import { EbookShowcasePart2 } from './components/EbookShowcasePart2';
import { ProofCredibility } from './components/ProofCredibility';
import { Guarantee } from './components/Guarantee';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
import { LegalFooter } from './components/LegalFooter';
export function App() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return <main className="min-h-screen w-full font-sans text-[#3D3229] bg-[#FBF8F4] overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmotionalHook data-id="element-2" />
      <ProblemAgitation data-id="element-3" />
      <PackPresentation data-id="element-4" />
      <EbookShowcase data-id="element-5" />
      <EbookShowcasePart2 data-id="element-6" />
      <ProofCredibility data-id="element-7" />
      <Guarantee data-id="element-8" />
      <OfferSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <LegalFooter data-id="element-12" />
    </main>;
}